// src/pages/home/confirmNewsletter.js

import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './home.css';  // or wherever your styling is
import { baseUrl } from '../../component/network/url';
import { Network } from '../../component/network/network';

const ConfirmNewsletter = () => {
  const [confirmationMessage, setConfirmationMessage] = useState('');
  const location = useLocation();
  const network = Network();

  useEffect(() => {
    // 1. Extract query params from URL
    const searchParams = new URLSearchParams(location.search);
    const newsletterCode = searchParams.get('newslettercode');
    const email = searchParams.get('email');

    // 2. If both exist, call the confirmation API
    if (newsletterCode && email) {
      // GET request to your `newsletter-bestaetigt` endpoint
      // Make sure to encode email if it has special chars
      network
        .getRequest(
          `${baseUrl}AccountAPI/newsletter/confirm?newslettercode=${newsletterCode}&email=${encodeURIComponent(email)}`
        )
        .then((response) => {
          if (response && response.Message) {
            setConfirmationMessage(response.Message);
          } else {
            setConfirmationMessage('Fehler beim Bestätigen des Newsletters.');
          }
        })
        .catch((error) => {
          setConfirmationMessage('Fehler beim Bestätigen des Newsletters.');
        });
    }
  }, [location.search, network]);

  return (
    <div className='page-middle-height mt-5'>
      <div className='email-confirmation'>
        <h3>{confirmationMessage}</h3>
      </div>
    </div>
  );
};

export default ConfirmNewsletter;
